import { bulbIcon } from './inline-icons';

export function generateDescriptionMarkup(contentFn) {
	return `
		<div class="rs-popover"">
			<div class="rs-popover__icon"">
				${bulbIcon}
			</div>
			<div class="rs-popover__content">
				${contentFn()}
			</div>
		</div>
	`;
}

export function generateDescriptionMarkupWithImage(contentFn, titleFn) {
	return `
		<div class="rs-popover gif-popover">
			<div class="rs-popover__header">
				${bulbIcon}
				<span>
					${titleFn()}
				</span>
			</div>
			<div class="rs-popover__content">
				${contentFn()}
			</div>
		</div>
	`;
}
